module.exports = __webpack_public_path__ + "img/bg-lucky-draw-list.84ec6167.png";